<template>
  <div> 

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 150px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in getButtons(selectedRow)" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="obj.command()"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :key="customersTableKey"
      :value="activities"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      dataKey="activityId"
      :rowHover="true"
      :selection.sync="selectedActivities1"
      :loading="loading"
      :filters="filters1"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Activities"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
      :style="{ 'width': '100%' }" 
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <template #empty> No activities found. </template>
      <template #loading> Loading activities data. Please wait. </template>
      <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
      <Column 
        header="Actions"
        headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
        :frozen="true"
      >
        <template #body="slotProps">
          <div  
              style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
          >
            <Button 
              icon="pi pi-ellipsis-h" 
              class="p-button-rounded p-button-text"
              @click="toggleActions($event, slotProps.data)"
            />
          </div>
        </template>
      </Column>
      <Column 
        v-for="(col, index) of colSelectedFieldsForTable" 
        :key="col.dbField + '_' + index"
        :header="col.fieldName" 
        :sortable="true"
        :headerStyle="'width: ' + col.defWidth + 'px;height: 41px;'" 
      >
        <template #body="slotProps">
          <div
            style="height: 40px; padding: 10px 0px;"
            @click="call(slotProps.data, col)"
            :class="getStyle1(slotProps.data, col)"
          >
            {{ getToShow(slotProps.data, col) }}
          </div>
        </template>
      </Column>
      <Column 
        headerStyle="width: 9em;" 
        header="Status" 
        :sortable="true"
      >
        <template #body="slotProps">
          <span 
            v-on:click="changeStatus(slotProps.data)"
            :class="'ignore pointer badge ' + getStyle(slotProps.data)" 
          >
              {{ getStatusObj(slotProps.data) ? getStatusObj(slotProps.data)['statusName'] : '' }}
          </span>
                
          <OverlayPanel 
            ref="statuses" 
            appendTo="body" 
            :showCloseIcon="true" 
            id="statuses" 
            style="width: 130px"
          > 
            <div
              v-for="(val, index) in tempActivityStatuses"
              :key="index"
            >
              <span 
                @click="updateStatus(val)" 
                :class="'ignore pointer badge ' + getStyle2(val)" 
              >
                {{ val.statusName }}
              </span>
              <br />
              <br />
            </div>
          </OverlayPanel>
          <!-- <span :class="'customer-badge status-' + getStyle(slotProps.data.activityStatus.statusName)" style="font-size: 18px;">{{ slotProps.data.activityStatus.statusName }}</span> -->
          <!-- <span :class="'product-badge status-INSTOCK'" style="font-size: 18px;">{{ slotProps.data.activityStatus.statusName }}</span> -->
          <!-- <Badge value="slotProps.data.activityStatus.statusName" severity="danger"></Badge> -->
        </template>
      </Column>
    </DataTable>

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDeleteActivity" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <ActivityMeetingDialog
      :meetingDialog="meetingDialog"
      :reload="reloadMeetingDialog"
      :activity="activity"
      :sendingRequest="sendingRequest"
      @close="meetingDialog = false"
      @save="saveMeetingDetails"
    />

    <ActivityRescheduleDialog
      :scheduleDialog="scheduleDialog"
      :reload="reloadScheduleDialog"
      :activity="activity"
      :sendingRequest="sendingRequest"
      :task="kindOfRecord(activity) === 'TASK'"
      @close="scheduleDialog = false"
      @save="saveScheduleDetails"
    />

    <CommentBox
      :reload="reloadCommentBox"
      :commentDialog="commentDialog"
      label="Please give details below"
      :sendingRequest="sendingRequest"
      @close="commentDialog = false"
      @save="addComment"
    />

  </div>
</template>
<script>
import ActivityService from "@/service/ActivityService"
import FiltersService from "@/service/FiltersSerice"

import ActivityMeetingDialog from './ActivityMeetingDialog'
import ActivityRescheduleDialog from './ActivityRescheduleDialog'
import CommentBox from '@/mbp/universalComponents/quotation/CommentBox'

// import Badge from 'primevue/badge';

import {
  activityRequest,
  columnSelectionRequest
} from '../sendRequest'
import { opensResultDialog, nextStatusesFor } from '../../activityCompletion.js'
import { kindOfRecord } from '../../activityKind.js'

export default {
  components: {
    ActivityMeetingDialog,
    ActivityRescheduleDialog,
    CommentBox,
    // Badge
  },
  props: [
    "dbView",
    "activities", 
    "loading", 
    "colSelectedFieldsForTable", 
    "dbViewFields",
    "filters1"
  ],
  data: () => ({
    activityService: new ActivityService(),
    filtersService: new FiltersService(),
    selectedActivities1: null,
    activitystatuses: [],
    activity: {},
    displayConfirmation: false,
    tempDelete: {},
    customersTableKey1: 0,
    selected: [],
    tempActivityStatuses: [],
    meetingDialog: false,
    reloadMeetingDialog: 0,
    commentDialog: false,
    reloadCommentBox: 0,
    scheduleDialog: false,
    reloadScheduleDialog: 0,
    sendingRequest: false,
    selectedRow: null
  }),
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
    customersTableKey: {
      set(val) {
        this.customersTableKey1++
      },
      get() {
        return 'customersTableKey' + this.customersTableKey1.toString()
      }
    }
  },
  created() {
    
    
    this.activityService
      .getAllActiveActivityStatuses()
      .then((data) => (this.activitystatuses = data))
      .catch(err => {
        
              
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity statuses",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeActivityStatuses"'
        })
      })
  },
  watch: {
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        columnSelectionRequest(this, 'ActivitiesDataTable.vue')
      }
    },
    activities(val) {
      
      this.customersTableKey++
    },
    colSelectedFieldsForTable(val) {
      
      this.customersTableKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    kindOfRecord,
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    addComment(comment) {
      this.sendingRequest = true
      
      
      this.activityService
        .updateActivityStatus(this.activity.activityId, {
          newStatusId: this.tempObj.id,
          resultNotes: comment,
        })
        .then(data => {
          this.sendingRequest = false
          this.commentDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })

          this.$emit('reload')
        })
        .catch(error => {
          this.sendingRequest = false
          this.commentDialog = false

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000,
          })
        })
    },
    saveScheduleDetails(activity) {
      this.sendingRequest = true
      

      this.activityService
        .updateActivityStatus(this.activity.activityId, {
          newStatusId: this.tempObj.id,
          NewStartDate: activity.startDate,
          NewStarTime: activity.startTime,
          NewDuration: activity.duration,
          NewEndDate: activity.endDate,
          NewEndTime: activity.endTime,
        })
        .then(data => {
          this.scheduleDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })

          this.$emit('reload')
        })
        .catch(error => {
          this.scheduleDialog = false

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000,
          })
        })

    },
    saveMeetingDetails(activity) {
      this.sendingRequest = true
      

      let obj = {}

      if (activity.activityType) {
        obj = {
          newStatusId: this.tempObj.id,
          resultId: activity.activityResult.id,
          resultNotes: activity.notes,
          NewActivityType: activity.activityType.id,
          NewSubject: activity.subject,
          NewStartDate: activity.startDate,
          NewStarTime: activity.startTime,
          NewDuration: activity.duration,
          NewEndDate: activity.endDate,
          NewEndTime: activity.endTime,
        }
      } else {
        obj = {
          newStatusId: this.tempObj.id,
          resultId: activity.activityResult.id,
          resultNotes: activity.notes
        }
      }

      this.activityService
        .updateActivityStatus(this.activity.activityId, obj)
        .then(data => {
          this.sendingRequest = false
          this.meetingDialog = false

          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Status updates.",
            life: 5000,
          })

          this.$emit('reload')
        })
        .catch(error => {
          this.sendingRequest = false
          this.meetingDialog = false

          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while updating status.",
            life: 5000,
          })
        })

    },
    getStatusObj(d) {
      var data = null
      if (d) {
        if (d.activityStatus) {
          data = d.activityStatus
        } else if (d.activityStatusName) {
          data = {
            statusName: d.activityStatusName,
            id: d.activityStatusId,
            colourCode: d.colourCode,
            statusCode: d.statusCode,
            active: d.active
          }
        }
      }
      return data
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    call(data, col) {
      // 
      if ( col.field === 'quote.quoteVer' ) {
        this.$router.push({
          path: "/quotations/" + data.quote.quoteVerId + "/detail",
          params: { quoteVerId: data.quote.quoteVerId, quote: data.quote },
        });
      } else if ( col.field === 'customer.custName' ) {
        this.$router.push({
          path: "/customers/" + data.customer.customerId + "/detail",
          params: { custid: data.customer.customerId },
        });
      }
    },
    getStyle1(data, col) {
      if (
        col.field === 'quote.quoteVer' ||
        col.field === 'customer.custName'
      ) {
        return 'under_lined'
      }
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 
      if (a.length > 1) {
        return data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        return data[col.dbField]
      }
    },
    viewHistory(data) {
      this.$router.push({
        path: "/activities/" + data.activityId + "/history",
        params: { activityId: data.activityId },
      });
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
						this.editActivity(data)
					}
				},
				{
					label: 'History',
					icon: 'pi pi-inbox',
					command: () => {
						this.viewHistory(data)
					}
        }
      ]
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteActivity');
      if (
        permission 
        && permission.permissionLevel 
        && permission.permissionLevel !== 0
        && (
          (
            this.selectedRow 
            && this.selectedRow.activityStatusName
            && this.selectedRow.activityStatusName !== 'Completed'
          )
          || 
          (
            this.selectedRow 
            && this.selectedRow.activityStatus
            && this.selectedRow.activityStatus.statusName
            && this.selectedRow.activityStatus.statusName !== 'Completed'
          )
        )
      ) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteActivity(data)
            }
          }
        )
      }
      return buttons
    },
    updateStatus(val) {
      if (this.activity && this.activity.activityId && val && val.id) {
        this.$refs.statuses.hide();
        this.sendingRequest = false
              
        if (this.activity.activityTypeName && this.activity.activityTypeId) {
          this.activity.activityType = {
            activityTypeName: this.activity.activityTypeName,
            activityTypeId: this.activity.activityTypeId,
          }
        }

        if (this.activity)
        
        if (opensResultDialog(val.statusName, this.activity.activityStatus.statusName)) {
          this.tempObj = val
          this.meetingDialog = true
          this.reloadMeetingDialog++

        } else if (val.statusName === 'Rescheduled') {
          this.tempObj = val
          this.scheduleDialog = true
          this.reloadScheduleDialog++

        } else if (val.statusName === 'Cancelled') {
          this.tempObj = val
          this.commentDialog = true
          this.reloadCommentBox++

        } else {
          this.activity.activityStatus = val
          this.sendingRequest = true
              
          
          this.activityService
            .updateActivityStatus(this.activity.activityId, {
              newStatusId: val.id
            })
            .then(data => {
              this.sendingRequest = false
              
              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Status updates.",
                life: 5000,
              })

              this.$emit('reload')
            })
            .catch(error => {
              this.sendingRequest = false
              
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while updating status.",
                life: 5000,
              })
            })

        }
      }
    },
    changeStatus(d) {
      
      var activity = d
      activity.activityStatus = this.getStatusObj(d)
      

      if (!(activity.activityStatus.statusName === 'Completed' || activity.activityStatus.statusName === 'Cancelled') && this.activitystatuses) {

        this.tempActivityStatuses = nextStatusesFor(
          activity.activityStatus.statusName,
          this.activitystatuses
        )

        // 

        this.activity = {...activity}
        this.$refs.statuses.toggle(event);

      }
    },
    getColorCode(data) {
      // https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data.colourCode) {
        return data.colourCode
      } else if (data.statusName && data.statusName.toLowerCase() === 'upcomming') {
        return 'badge-primary'
      } else if (data.statusName && data.statusName.toLowerCase() === 'task') {
        return 'badge-warning'
      } else if (data.statusName && data.statusName.toLowerCase() === 'overdue') {
        return 'badge-danger'
      } else if (data.statusName && data.statusName.toLowerCase() === 'completed') {
        return 'badge-success'
      } else {
        return 'badge-dark'
      }
    },
    getStyle2(d) {
      return this.getColorCode(d)
    },
    getStyle(d) {
      var data = this.getStatusObj(d)

      if (data && data.colourCode) {
      console.log(data)
      }

      if (!data) {
        return ''
      } else {
        return this.getColorCode(data)
      }
      // if (data && data.toLowerCase() === 'upcomming') {
      //   return 'NEW'
      // } else if (data && data.toLowerCase() === 'task') {
      //   return 'PROPOSAL'
      // } else if (data && data.toLowerCase() === 'overdue') {
      //   return 'UNQUALIFIED'
      // } else if (data && data.toLowerCase() === 'completed') {
      //   return 'QUALIFIED'
      // } else {
      //   return 'RENEWAL'
      // }
    },
    viewActivity(data) {
      this.$store.dispatch('activities/setActivityForTabs', data)
      this.$router.push({
        path: "/activities/" + data.activityId + "/detail",
        params: { activityId: data.activityId },
        // query: { activity: data }
      });
    },
    editActivity(data) {
      this.$emit("editActivity", data);
    },
    deleteActivity(data) {
      if (
        (
          data 
          && data.activityStatusName
          && data.activityStatusName !== 'Completed'
        )
        || 
        (
          data 
          && data.activityStatus
          && data.activityStatus.statusName
          && data.activityStatus.statusName !== 'Completed'
        )
      ) {
        this.tempDelete = data
        this.displayConfirmation = true
      }
    },
    confirmDeleteActivity() {
      this.displayConfirmation = false
      this.$emit("confirmDeleteActivity", this.tempDelete);
    },
  },
};
</script>

<style scoped lang="scss">

</style>